import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Normalizes any web link to prevent relative navigation errors (e.g. mdpanel.vip/link.com)
 */
export function normalizeUrl(url) {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (!trimmed || trimmed === '#') return '#';
  if (
    trimmed.startsWith('#') ||
    trimmed.startsWith('/') ||
    trimmed.startsWith('mailto:') ||
    trimmed.startsWith('tel:') ||
    trimmed.startsWith('whatsapp:')
  ) {
    return trimmed;
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  if (trimmed.startsWith('//')) {
    return `https:${trimmed}`;
  }
  return `https://${trimmed}`;
}

/**
 * Detects if a URL or handle is for Telegram
 */
export function isTelegramLink(val) {
  if (!val || typeof val !== 'string') return false;
  const trimmed = val.trim().toLowerCase();
  return (
    trimmed.startsWith('https://t.me/') ||
    trimmed.startsWith('http://t.me/') ||
    trimmed.startsWith('t.me/') ||
    trimmed.startsWith('telegram.me/') ||
    trimmed.startsWith('https://telegram.me/') ||
    trimmed.startsWith('tg://') ||
    trimmed.startsWith('@')
  );
}

/**
 * Formats Telegram URL cleanly
 */
export function formatTelegramUrl(val) {
  if (!val || typeof val !== 'string') return '';
  const trimmed = val.trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('https://t.me/') || trimmed.startsWith('http://t.me/') || trimmed.startsWith('tg://')) {
    return trimmed;
  }
  if (trimmed.startsWith('t.me/') || trimmed.startsWith('telegram.me/')) {
    return `https://${trimmed}`;
  }
  if (trimmed.startsWith('@')) {
    return `https://t.me/${trimmed.slice(1)}`;
  }
  if (!trimmed.includes('/') && !trimmed.includes('.')) {
    return `https://t.me/${trimmed}`;
  }
  return normalizeUrl(trimmed);
}

/**
 * Formats WhatsApp URL cleanly
 */
export function formatWhatsAppUrl(val, message = '') {
  if (!val || typeof val !== 'string') return '';
  const trimmed = val.trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('https://wa.me/') || trimmed.startsWith('http://wa.me/')) {
    return trimmed;
  }
  if (trimmed.startsWith('wa.me/')) {
    return `https://${trimmed}`;
  }
  const digits = trimmed.replace(/\D/g, '');
  if (digits) {
    const textParam = message ? `?text=${encodeURIComponent(message)}` : '';
    return `https://wa.me/${digits}${textParam}`;
  }
  return normalizeUrl(trimmed);
}
